import { http, HttpResponse } from 'msw';

const BASE = import.meta.env?.VITE_API_BASE_URL ?? 'http://localhost:8000';

let killSwitchState = {
  active: false,
  activated_at: null as string | null,
  reason: null as string | null,
  activated_by: null as string | null,
};

export const demoKillSwitchHandlers = [
  // ── Get kill switch status ────────────────────────────────────────────────
  http.get(`${BASE}/api/v1/system/kill-switch`, () => {
    return HttpResponse.json(killSwitchState);
  }),

  // ── Activate kill switch ──────────────────────────────────────────────────
  http.post(`${BASE}/api/v1/system/kill-switch`, async ({ request }) => {
    const body = (await request.json()) as Record<string, unknown>;
    killSwitchState = {
      active: true,
      activated_at: new Date().toISOString(),
      reason: (body['reason'] as string) ?? 'Demo activation',
      activated_by: 'user:42',
    };
    return HttpResponse.json(killSwitchState);
  }),

  // ── Deactivate kill switch ────────────────────────────────────────────────
  http.delete(`${BASE}/api/v1/system/kill-switch`, () => {
    killSwitchState = {
      active: false,
      activated_at: null,
      reason: null,
      activated_by: null,
    };
    return HttpResponse.json(killSwitchState);
  }),
];
